import type { AgentSessionSummary } from 'agentic-platform-schema';
import moment from 'moment';

/** Falls back to the creation time until a title is generated or set. */
export function getAgenticChatSessionTitle(session: AgentSessionSummary) {
  return session.title ?? moment(session.created).format('MMM D, YYYY h:mm A');
}
